import { render, staticRenderFns } from "./SkeletonPeopleTourRewards.vue?vue&type=template&id=ca017634&scoped=true"
import script from "./SkeletonPeopleTourRewards.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonPeopleTourRewards.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca017634",
  null
  
)

export default component.exports